import { LOGO_PATHS, LOGO_VIEWBOX, logoWidth } from "@kalori/brand/logo";

/**
 * ロゴ（インライン SVG）。社名を文字で組まないための部品。
 * 塗りは currentColor ＝ 置き場所の `color`（styles.css の `--logo`）が決める。
 * `label={null}` は隣に同じ名前を読み上げる文字がある時（リンクの aria-label など）。
 */
export function KaloriLogo({ height, label = "kalori", className }: { height: number; label?: string | null; className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={LOGO_VIEWBOX}
      width={logoWidth(height)}
      height={height}
      fill="currentColor"
      className={className}
      focusable="false"
      {...(label === null ? { "aria-hidden": true } : { role: "img", "aria-label": label })}
    >
      {LOGO_PATHS.map((d) => <path key={d} d={d} />)}
    </svg>
  );
}
